<template>
  <BContainer
    class="p-0"
    fluid
  >
    <ValidationObserver
      ref="formInformation"
    >
      <form
        role="form"
        novalidate
        @submit.prevent
      >
        <BRow>

          <BCol
            cols="12"
            md="3"
          >
            <BFormGroup
              label="First Name"
              label-for="fFirstName"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fFirstName"
                v-model="formInformation.first_name"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="3"
          >
            <BFormGroup
              label="Middle Name"
              label-for="fMiddleName"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fMiddleName"
                v-model="formInformation.middle_name"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="3"
          >
            <BFormGroup
              label="Last Name"
              label-for="fLastName"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fLastName"
                v-model="formInformation.last_name"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="3"
          >
            <BFormGroup
              label="Suffix Name"
              label-for="fSuffixName"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fSuffixName"
                v-model="formInformation.suffix_name"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="3"
          >
            <BFormGroup
              label="Mobile Number"
              label-for="fMobileNumber"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fMobileNumber"
                v-model="formInformation.mobile_number"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="6"
          >
            <BFormGroup
              label="Email"
              label-for="fEmail"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fEmail"
                v-model="formInformation.email"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="3"
          >
            <BFormGroup
              label="Birth Date"
              label-for="fBirthDate"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fBirthDate"
                v-model="formInformation.birth_date"
                type="date"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="3"
          >
            <BFormGroup
              label="Gender"
              label-for="fGender"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fGender"
                v-model="formInformation.gender"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol cols="12" />

          <BCol
            cols="12"
            md="6"
          >
            <BFormGroup
              label="Province"
              label-for="fProvince"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fProvince"
                v-model="formInformation.province_name"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="6"
          >
            <BFormGroup
              label="Municipality"
              label-for="fMunicipality"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fMunicipality"
                v-model="formInformation.municipality_name"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="6"
          >
            <BFormGroup
              label="Barangay"
              label-for="fBarangay"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fBarangay"
                v-model="formInformation.barangay_name"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
          >
            <BFormGroup
              label="Present Address"
              label-for="fAddress"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormTextarea
                id="fAddress"
                v-model="formInformation.address"
                rows="3"
                max-rows="5"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
          >
            <BFormGroup>
              <BFormCheckbox
                id="fBiglandOwner"
                v-model="formInformation.is_blo"
                switch
                value="1"
                name="is_blo"
                unchecked-value="0"
                disabled
              >
                Is Big Land Owner?
              </BFormCheckbox>
            </BFormGroup>
          </BCol>
          <BCol
            cols="12"
          >
            <BFormGroup>
              <BFormCheckbox
                id="fAljayUser"
                v-model="formInformation.is_aljay"
                switch
                value="1"
                name="is_aljay"
                unchecked-value="0"
                disabled
              >
                Is Aljay Product User?
              </BFormCheckbox>
            </BFormGroup>
          </BCol>
        </BRow>
      </form>
    </ValidationObserver>
  </BContainer>
</template>
<script>
import MxMisc from '@/mixins/misc'

import { SAuditCustomer } from '@/services/audit'

export default {
  name: 'VAuditCustomerInformations',

  mixins: [
    MxMisc
  ],

  emits: [
    'updated'
  ],

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      fetching: {
        gender: false
      },
      options: {
        gender: ['Male', 'Female']
      },
      formInformation: {
        id: '',
        // cluster_id: '',
        // cluster_name: '',
        province_id: '',
        province_name: '',
        municipality_id: '',
        municipality_name: '',
        barangay_id: '',
        barangay_name: '',
        first_name: '',
        middle_name: '',
        last_name: '',
        suffix_name: '',
        email: '',
        mobile_number: '',
        birth_date: '',
        gender: '',
        address: '',
        status: 'Verified',
        is_blo: 0,
        is_aljay: 0,
        active: 1
      }
    }
  },

  methods: {

    setInformation (customer) {
      this.formInformation = Object.assign(this.formInformation, customer)
    },

    getInformation () {
      return this.formInformation
    },

    async showInformation (customerID) {
      return await SAuditCustomer.show(customerID).then(
        ({ data: { customer } }) => customer
      )
    },

    async viewInformation (customerInformation) {
      this.state.editing = true

      this.formInformation = Object.assign(this.formInformation, {
        id: customerInformation.id,
        first_name: customerInformation.first_name,
        middle_name: customerInformation.middle_name,
        last_name: customerInformation.last_name,
        suffix_name: customerInformation.suffix_name,
        email: customerInformation.email,
        mobile_number: customerInformation.mobile_number,
        birth_date: customerInformation.birth_date,
        gender: customerInformation.gender,
        // cluster_id: customerInformation.cluster_id,
        // cluster_name: customerInformation.cluster.cluster_name,
        province_id: customerInformation.province_id,
        province_name: customerInformation.province.province_name,
        municipality_id: customerInformation.municipality_id,
        municipality_name: customerInformation.municipality.municipality_name,
        barangay_id: customerInformation.barangay_id,
        barangay_name: customerInformation.barangay.barangay_name,
        address: customerInformation.address,
        active: customerInformation.active,
        is_blo: customerInformation.is_blo,
        is_aljay: customerInformation.is_aljay,
        status: customerInformation.status
      })
    },

    async validateInformation () {
      return new Promise((resolve, reject) => {
        this.$refs.formInformation.validate().then(
          isFormValid => {
            if (isFormValid) {
              return resolve(isFormValid)
            }
            return reject(new Error('Invalid Form'))
          }
        )
      })
    },

    async submitInformation () {
      return new Promise(resolve => {
        this.validateInformation().then(
          () => {
            this.swalConfirm({
              html: this.state.editing ? 'Update this Customer?' : 'Register this Customer?',
              confirmButtonText: this.state.editing ? 'Update' : 'Register',
              cancelButtonText: 'Discard',
              preConfirm: async () => {
                this.state.busy = true

                const createOrUpdate = () => {
                  return this.putInformation()
                }

                return createOrUpdate().catch(
                  ({ message }) => {
                    this.$refs.formInformation.setErrors(message.errors)
                  }
                ).finally(() => {
                  this.state.busy = false
                })
              }
            }).then(resolve)
          }
        ).catch(() => {
          this.swalInvalid()
        })
      })
    },

    async putInformation () {
      return await SAuditCustomer.put(this.formInformation).then(
        ({ data }) => data
      )
    }
  }
}
</script>
